module.exports = __webpack_public_path__ + "static/honda-1f9d0e28cd5e1fd8d2e736bf6fa8460a.png";